import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#size" }),
  /*#__PURE__*/_createTextVNode(" Size ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use attribute "),
  /*#__PURE__*/_createVNode("code", null, "size"),
  /*#__PURE__*/_createTextVNode(" to set additional sizes with "),
  /*#__PURE__*/_createVNode("code", null, "medium"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createVNode("code", null, "small"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createVNode("code", null, "mini"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_input_number, {
        style: {"margin-right":"5px"},
        modelValue: _ctx.num1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.num1 = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input_number, {
        style: {"margin-right":"5px"},
        size: "medium",
        modelValue: _ctx.num2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.num2 = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input_number, {
        style: {"margin-right":"5px"},
        size: "small",
        modelValue: _ctx.num3,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.num3 = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input_number, {
        size: "mini",
        modelValue: _ctx.num4,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.num4 = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
}